// extracted by mini-css-extract-plugin
export default {"mainWrapper":"AppWrapper_mainWrapper__T3yGf"};